
import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IListOpportunityHistory } from '../models/opportunityMarketList'

export class MarketHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/opportunitMarket/listHistoryById',
      requesterInfo,
    })
  }

  public async historyByID(request: number): Promise<IListOpportunityHistory[]> {
    return await this.postAsync<IListOpportunityHistory[]>(request)
  }
}
